<template>
  <p>{{ text }}</p>
  <p class="tw:text-sm tw:text-gray-600 tw:my-4">{{ note }}</p>
</template>
<script setup>
defineProps({
  text: String,
  note: String,
})
</script>
